import React, { useState, useEffect } from 'react';
import Lottie from 'react-lottie';
import animationData from '@/lottie/globalLoading.json';
interface Props {
  width?: number;
  height?: number;
}

const Loading: React.FC<Props> = ({
  width = 20, height = 20
}) => {
  return (
    <Lottie options={{
      loop: true,
      autoplay: true,
      animationData,
      rendererSettings: {
        preserveAspectRatio: 'xMidYMid slice',  // 渲染设置，保持动画的纵横比
      }
      }}
      width={width}
      height={height}
    />
  )
}

export default Loading;
